"use strict";
window._theme = window._theme || {};
document.addEventListener('DOMContentLoaded',function(){
    const articleVarSelector = document.querySelectorAll('.article-select-cv')
    const artcileATC = document.querySelectorAll('.article-atc-grid')
    articleVarSelector?.forEach(item => {
      item.addEventListener('change',function(){
        const selectedOption = this.options[this.selectedIndex];
        const regPrice = selectedOption.getAttribute('price')
        const salePrice = selectedOption.getAttribute('compare')
        this.setAttribute('data-var-id', selectedOption.value);
        this.setAttribute('data-var-compare-price', regPrice)
        this.setAttribute('data-var-price', salePrice)
        const closestGrid = this.closest('.grid-item')
        if (closestGrid) {
          closestGrid.querySelector('.article-atc-grid').setAttribute('data-cv-id', selectedOption.value);
          closestGrid.querySelector('.article-grid-reg-price').innerText = regPrice
          closestGrid.querySelector('.article-grid-sale-price').innerText = salePrice
        }    
      })
    });
    artcileATC?.forEach(item=>{
      item.addEventListener('click',(e)=>{
        const cvId = parseInt(e.target.getAttribute('data-cv-id'))
        _theme.toggleLoading(1)
        Shopify.addItem(cvId, 1, function () {
          Shopify.getCart(function (cart) {
            _theme.MiniCart.lineItemChangeCallBack(cart, function () {
              _theme.toggleSideCart(1, null, true);
              _theme.toggleLoading(0);
            })
          })
        })
      })
    })
})